import { RecurringTypesEnum, SubscriptionProductNamesEnum } from "dash-common";
import { SubscriptionProduct } from "gql/generated.graphql";

type PlanVariant = Pick<
  SubscriptionProduct,
  "_id" | "name" | "recurringType" | "legacy"
>;

export interface ApiPlanSelection<T extends PlanVariant> {
  product?: T;
  offersCadenceChoice: boolean;
}

/**
 * The API plan is invite-only (DSH-898) and every plan card carries its own
 * subscribe button, so a picker shows exactly one API card: the variant billed
 * at the selected cadence, or the only one there is.
 */
export function selectApiPlanVariant<T extends PlanVariant>(
  products: T[],
  recurringType: RecurringTypesEnum,
  currentProductId?: string
): ApiPlanSelection<T> {
  const variants = products.filter(
    (product) =>
      product.name === SubscriptionProductNamesEnum.API &&
      (!product.legacy || product._id === currentProductId)
  );

  const product =
    variants.find((variant) => variant.recurringType === recurringType) ??
    variants.find((variant) => variant._id === currentProductId) ??
    variants[0];

  const cadences = new Set(variants.map((variant) => variant.recurringType));

  return { product, offersCadenceChoice: cadences.size > 1 };
}
